import { render, staticRenderFns } from "./Pdfjs.vue?vue&type=template&id=ce3be84c&"
import script from "./Pdfjs.vue?vue&type=script&lang=js&"
export * from "./Pdfjs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports